.container {
    padding: 20px 20px;
}

.title {
    font-family: Hanken Grotesk;
    font-size: 15px;
    color: #243a5c;
}

.value {
    font-family: LustTextMedium;
    font-size: 20px;
    color: #243a5c;
}
